// extracted by mini-css-extract-plugin
export default {"modal":"FxyQ30N_Et3uylfaI2V2"};